module.exports = __webpack_public_path__ + "static/media/get_30pt.a08252c7.png";